import React from 'react';
import BackSubheader from '../elements/BackSubheader';
import Header from '../elements/Header';

type BaseScreenProps = {
  children: React.ReactNode;
  title: string;
  style?: StyleSheet;
  rightView?: React.ReactNode;
  bottomView?: React.ReactNode;
  hideBack?: boolean;
  previousRoute?: string | null;
  accessibilityLabel?: string;
  accessibilityHint?: string;
};
export default class BaseScreen extends React.Component<BaseScreenProps> {
  static defaultProps = {
    hideBack: false,
  };

  render() {
    let HeaderComponent: any = BackSubheader;

    if (this.props.hideBack) {
      HeaderComponent = Header;
    }

    return (
      <HeaderComponent
        title={this.props.title}
        rightView={this.props.rightView}
        bottomView={this.props.bottomView}
        previousRoute={this.props.previousRoute}
        accessibilityLabel={this.props.accessibilityLabel}
        accessibilityHint={this.props.accessibilityHint}
      >
        {this.props.children}
      </HeaderComponent>
    );
  }
}
